<ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>

<div class="flex flex-col h-full p-1 md:p-1">

    <!-- Close button -->
    <div class="flex items-center justify-between">
        <!-- Toggle starred button -->
        <button class="ml-2" mat-icon-button matTooltip="Favorite" (click)="toggleStar(asset)">
            <mat-icon [ngClass]="{'text-orange-500 dark:text-red-400': asset?.favourite}"
                [svgIcon]="'heroicons_outline:star'"></mat-icon>
        </button>
        <a *ngIf="util.getIsWebApp()" mat-icon-button (click)="closeDrawer()">
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </a>

        <a *ngIf="!util.getIsWebApp()" mat-icon-button [routerLink]="['../../']">
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </a>
    </div>

    <!-- Name & Type -->
    <div class="flex flex-col items-start mt-1 px-4">
        <div class="text-xl font-medium my-2">{{asset?.name}}</div>
        <div class="mt-1 mb-1 px-1.5 rounded text-sm font-semibold leading-5 text-white"
            [class.bg-indigo-600]="asset?.type?.toUpperCase() === 'Folder'"
            [class.bg-red-600]="asset?.extension?.toUpperCase() === 'PDF'"
            [class.bg-blue-600]="asset?.extension?.toUpperCase() === 'DOC'"
            [class.bg-green-600]="asset?.extension?.toUpperCase() === 'XLS'"
            [class.bg-gray-600]="asset?.extension?.toUpperCase() === 'TXT'"
            [class.bg-amber-600]="asset?.extension?.toUpperCase() === 'JPG'">
            {{asset?.extension?.toUpperCase()}}
        </div>
    </div>

    <mat-tab-group [selectedIndex]="selectedTab" class="asset-tab-group-1">

        <!-- Tab - Info -->
        <mat-tab label="Info" class="tab-item-info">

            <!-- Preview -->
            <div class="items-center cursor-pointer [9/6]" style="height:150px;" *ngIf="asset.thumbnail"
                (click)="asset.type === 'FILE' && util.onThumbnailClick(asset)">
                <div class="flex items-center justify-center h-full border rounded-lg bg-gray-50 dark:bg-card">
                    <ng-container>
                            <img class="icon-size-24 text-hint" [src]="sanitizer.bypassSecurityTrustUrl(asset.thumbnail)">
                    </ng-container>
                </div>
            </div>

            <div class="items-center [9/6]" style="height:150px;" *ngIf="!asset.thumbnail"
                (click)="asset.type === 'FILE' && util.onThumbnailClick(asset)"
                [class.cursor-pointer]="asset.type === 'FILE'">
                <div class="flex items-center justify-center h-full border rounded-lg bg-gray-50 dark:bg-card">
                    <ng-container *ngIf="asset.type === 'FOLDER'">
                        <mat-icon class="icon-size-24 text-hint" [svgIcon]="'heroicons_outline:folder'"></mat-icon>
                    </ng-container>
                    <ng-container *ngIf="asset.type !== 'FOLDER'">
                        <mat-icon class="icon-size-24 text-hint" [svgIcon]="'heroicons_outline:document'"></mat-icon>
                    </ng-container>
                </div>
            </div>




            <!-- Labels -->
            <div class="flex items-center justify-between mt-4">
                <div class="text-medium font-medium">Labels</div>
                <!-- Toggle labels button & menu -->
                <button class="ml-auto" mat-icon-button [matMenuTriggerFor]="toggleLabelMenu">
                    <mat-icon [svgIcon]="'heroicons_outline:tag'"></mat-icon>
                </button>
                <mat-menu #toggleLabelMenu="matMenu" class="file-manager-item-action-menu-sub">
                    <ng-container *ngFor="let label of labels; trackBy: trackByFn">
                        <button mat-menu-item (click)="toggleLabel(asset.id, label.id, checkbox)" matRipple>
                            <mat-checkbox class="pointer-events-none label-chip" #checkbox 
                                [ngClass]="labelColors[label.color].combined" [color]="'primary'"
                                [checked]="selectedLabel(label.id, asset.labels)" [disableRipple]="true">
                                {{label?.name}}
                            </mat-checkbox>

                        </button>
                    </ng-container>
                </mat-menu>
            </div>
            <ng-container *ngIf="asset.labels && asset.labels.length > 0">
                <div class="flex flex-wrap items-center justify-start -mx-1">
                    <ng-container *ngFor="let label of asset.labels">
                        <div class="m-1 py-0.5 px-2.5 rounded-full text-sm font-medium whitespace-nowrap"
                            [ngClass]="labelColors[label.color].combined">
                            {{label.name}}
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <!-- Information -->
            <div class="text-medium font-medium mt-4">Information</div>
            <div class="flex flex-col mt-4 border-t border-b divide-y font-medium">
                <div class="flex items-center justify-between py-1">
                    <div class="text-secondary">Created By</div>
                    <div>{{asset?.createdBy | fullName}}
                    </div>
                </div>
                <div class="flex items-center justify-between py-1">
                    <div class="text-secondary">Created At</div>
                    <div>{{asset?.createdDate | date:'MM/dd/yyyy'}}</div>
                </div>
                <div class="flex items-center justify-between py-1">
                    <div class="text-secondary">Type</div>
                    <div>{{asset?.fileType}}</div>
                </div>
                <div class="flex items-center justify-between py-1" *ngIf="asset.size !=0">
                    <div class="text-secondary">Size</div>
                    <div>{{asset.size| fileSize}}</div>
                </div>
                <!-- <ng-container *ngIf="item.contents">
                    <div class="flex items-center justify-between py-1">
                        <div class="text-secondary">Contents</div>
                        <div>{{item.contents}}</div>
                    </div>
                </ng-container> -->
            </div>

            <!-- Description -->
            <div class="flex items-center justify-between mt-4">
                <div class="text-medium font-medium">Description</div>
                <button mat-icon-button toolTip="Edit Description"
                    (click)="desModal(descriptionModal, asset)">
                    <mat-icon
                        class="icon-size-4"
                        [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
                </button>
            </div>
            <div class="flex mt-2">
                <div class="py-2 cursor-pointer" (click)="desModal(descriptionModal, asset)">
                    <ng-container *ngIf="asset.description">
                        <div>{{asset?.description}}</div>
                    </ng-container>
                    <ng-container *ngIf="!asset.description">
                        <div class="italic text-secondary">Click here to add a description</div>
                    </ng-container>
                </div>
            </div>

            <div class="flex items-center justify-between mt-4">
                <div class="text-medium font-medium">Location</div>
                <button 
                    (click)="goToParent(asset.parent.id)" 
                    type="button" 
                    class="py-2.5 px-5 me-2  text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
                    {{asset?.parent?.name}}
                </button>
            </div>

            <!-- Actions -->
            <div class="flex flex-wrap justify-between gap-3 mt-8">
                <button mat-flat-button [color]="'primary'" *ngIf="asset.type == 'FILE'"
                    (click)="_fileManagerService.openDialog_download(asset)">
                    <mat-icon svgIcon="feather:download"></mat-icon>
                    <span class="ml-2">Download</span>
                </button>
                <button mat-flat-button [color]="'warn'" matTooltip="Delete"
                    (click)="openDialog_delete(asset.id, asset.type.toLowerCase())">
                    <mat-icon svgIcon="feather:trash-2"></mat-icon>
                    <span class="ml-2">Delete</span>
                </button>
            </div>
        </mat-tab>

        <!-- Tab - Activity -->
        <mat-tab label="Activity" class="tab-item-activities">
            <ng-template matTabContent>
                <activity [inputObj]="asset"></activity>
            </ng-template>
        </mat-tab>

        <!-- Tab - Notes -->
        <mat-tab label="Notes" class="tab-item-notes">
            <ng-template matTabContent>
                <notes-component [docId]="docId"></notes-component>
            </ng-template>
        </mat-tab>

        <!-- Tab - Permissions & Sharing -->
        <mat-tab label="Permissions" class="tab-item-permissions" *appIsDisplayed="'viewPermissions'">
            <ng-template matTabContent>
                <permissions-component [asset]="asset"></permissions-component>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>

<ng-template #descriptionModal>
    <div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6">
        <div class="flex flex-0 items-center justify-between border-b h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
            <div class="text-lg font-medium">Asset Description</div>
            <button mat-icon-button (click)="modalRef.close()">
                <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
    </div>
    
    <form class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
        <mat-label>Description</mat-label>
        <textarea [(ngModel)]="selectedAsset.description" rows="4" name="descrpt"
            class="block p-2.5 w-full text-sm mb-3 text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="description ..."></textarea>
       
        <div class="flex justify-end mt-5 sm:mt-0">
            <!-- Cancel -->
            <button class="ml-auto sm:ml-0 mr-2" mat-stroked-button (click)="cancel()">
                Cancel
            </button>

            <!-- Save -->

            <button class="order-first sm:order-last" mat-flat-button [color]="'primary'" (click)="updateDescription()"
              [disabled]="isLoading">
                <span *ngIf="!isLoading">
                    Save
                </span>
                <mat-progress-spinner *ngIf="isLoading" [diameter]="24"
                    [mode]="'indeterminate'"></mat-progress-spinner>
            </button>
        </div>
    </form>
    </div>

    
  </ng-template>